import {
    FilePickerAction,
    FilePickerConfiguration,
    FilePickerResult,
    lazyFilePicker,
    getSupportedFileProvidersFilter,
} from 'owa-filepicker';
import { FileSelectionFilter } from 'owa-fileprovider-store';
import type { NewAsset } from 'owa-timestream-asset-sdk-types';
import type { FileLinkPayload, FilePickerData } from '../schema';
import handleFilePickerResponse from '../utils/handleFilePickerResponse';

export default async function createNewFileAsset(
    pageX: number,
    pageY: number
): Promise<NewAsset<FileLinkPayload>[] | null> {
    const configuration: FilePickerConfiguration = {
        fileSelectionFilter: FileSelectionFilter.None,
        fileProvidersFilter: getSupportedFileProvidersFilter(),
        maxAllowedLocalFilesSize: 0,
        //userConfiguration: createFilePickerUserConfiguration(), // TODO - set config
        forcedAction: FilePickerAction.Share,
    };

    const filePicker = await lazyFilePicker.import();
    const filePickerResult: FilePickerResult = await filePicker(configuration);

    let filePickerResults: FilePickerData[] | null = null;
    if (filePickerResult) {
        filePickerResults = handleFilePickerResponse(filePickerResult);
    }

    return (
        filePickerResults?.map(fileData => {
            return {
                type: 'file',
                payload: {
                    filePickerLinkData: fileData.filePickerLinkData,
                    fileProvider: fileData.fileProvider,
                    fileId: fileData.fileId,
                    location: fileData.location,
                    providerEndpointUrl: '',
                    url: '',
                    thumbnailUrl: '',
                },
            };
        }) ?? null
    );
}
